import React, { useMemo } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';

type MarketingAreaContextType = {
  isHidden?: boolean;
  setIsHidden: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  customComponent?: React.ReactNode;
  setCustomComponent: React.Dispatch<React.SetStateAction<React.ReactNode>>;
};

export const MarketingAreaContext =
  React.createContext<MarketingAreaContextType>({
    setIsHidden: () => {},
    setCustomComponent: () => {},
  });

export const MarketingAreaContextProvider = (props: {
  children: React.ReactNode;
}) => {
  const [isHidden, setIsHidden] = React.useState<boolean | undefined>(
    undefined,
  );
  const [customComponent, setCustomComponent] = React.useState<
    React.ReactNode | undefined
  >();
  const { isXL } = useScreenSize();

  const ctx = useMemo(() => {
    const hideMarketingArea = isXL === false || isHidden === true;
    return {
      isHidden: hideMarketingArea,
      setIsHidden,
      customComponent: hideMarketingArea ? undefined : customComponent,
      setCustomComponent,
    };
  }, [customComponent, isHidden, isXL]);

  return (
    <MarketingAreaContext.Provider value={ctx}>
      {props.children}
    </MarketingAreaContext.Provider>
  );
};

export function useMarketingAreaContext(): MarketingAreaContextType {
  return React.useContext(MarketingAreaContext);
}
